/*efectos menu*/
    const menuButton = document.getElementById('menu-button');
    const mobileMenu = document.getElementById('mobile-menu');

    // Menú móvil
    menuButton.addEventListener('click', () => {
      menuButton.classList.toggle('active');
      mobileMenu.classList.toggle('hidden');
      document.body.classList.toggle('overflow-hidden');
    });


    // Efecto de scroll
    window.addEventListener('scroll', () => {
      const header = document.querySelector('header');
      const scrollY = window.scrollY;
      
      header.style.backdropFilter = scrollY > 100 ? 'blur(16px)' : 'blur(8px)';
      
    });

    // Inicializar efecto de blur dinámico
    const header = document.querySelector('header');
    header.style.transition = 'backdrop-filter 0.3s ease, background-color 0.3s ease';

/*fin js menu*/


/*slider events*/
var swiper = new Swiper(".sliderEvent", {
  slidesPerView: 1,
  spaceBetween: 30,
  loop: true,
  pagination: {
    el: ".sliderEvent .swiper-pagination.swiper-principal",
    clickable: true,
  },
  navigation: {
    nextEl: ".sliderEvent .swiper-button-next.principal",
    prevEl: ".sliderEvent .swiper-button-prev.principal",
  },
});

/*slider nosotros*/
var swiper = new Swiper("#sliderSomos", {
  slidesPerView: 1,
  spaceBetween: 30,
  loop: true,
  pagination: {
    el: "#sliderSomos .swiper-pagination.swiper-principal",
    clickable: true,
  },
  navigation: {
    nextEl: "#sliderSomos .swiper-button-next.principal",
    prevEl: "#sliderSomos .swiper-button-prev.principal",
  },
});

/*slider nosotros*/
var swiper = new Swiper("#testimonios", {
  slidesPerView: 1,
  spaceBetween: 30,
  loop: true,
  pagination: {
    el: "#testimonios .swiper-pagination.swiper-principal",
    clickable: true,
  },
  navigation: {
    nextEl: "#testimonios .swiper-button-next.principal",
    prevEl: "#testimonios .swiper-button-prev.principal",
  },
});


jQuery(document).ready(function($) {
    $('.sliderProgramas').each(function() {
        var unique_id = $(this).attr('id').replace('slider-', '');
        new Swiper("#slider-" + unique_id, {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next.principal-" + unique_id,
                prevEl: ".swiper-button-prev.principal-" + unique_id,
            },
            pagination: {
                el: ".swiper-pagination.swiper-principal-" + unique_id,
                clickable: true,
            },
        });
    });

    /**acordion */
    $('.acc-btn').click(function(){
        if ( $(this).next().is( ":hidden" ) ) {
          
          $('.acc-content').slideUp('selected');
          $(this).next().slideDown('selected');
        } else {
          
          $(this).next().slideUp('selected');
        };
    });

    $('.acc-btn2').click(function(){
        if ( $(this).next().is( ":hidden" ) ) {
          
          $('.acc-content2').slideUp('selected');
          $(this).next().slideDown('selected');
        } else {
          
          $(this).next().slideUp('selected');
        };
    });


});

/*slider encuentros
var swiper = new Swiper(".sliderProgramas", {
  slidesPerView: 1,
  spaceBetween: 30,
  pagination: {
    el: ".swiper-pagination .swiper-principal",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next .principal",
    prevEl: ".swiper-button-prev .principal",
  },
});

*/

/*slider expositores
var swiperEx = new Swiper(".mySwiperEx", {
      slidesPerView: 1,
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
       breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    });
*/
/*
jQuery(document).ready(function($) {

  /*acordion*/
  /*$('.acc-btn').click(function(){
    alert("sd00");
    if ( $(this).next().is( ":hidden" ) ) {
      $('.acc-content').slideUp('selected');
      $(this).next().slideDown('selected');
    } else {
      $(this).next().slideUp('selected');
    };
});

});*/

